import _classCallCheck from "/workspace/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _slicedToArray from "/workspace/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { coerce, equals as equalBytes } from '../bytes.js';
import * as varint from '../varint.js';
export var create = function create(code, digest) {
  var size = digest.byteLength;
  var sizeOffset = varint.encodingLength(code);
  var digestOffset = sizeOffset + varint.encodingLength(size);
  var bytes = new Uint8Array(digestOffset + size);
  varint.encodeTo(code, bytes, 0);
  varint.encodeTo(size, bytes, sizeOffset);
  bytes.set(digest, digestOffset);
  return new Digest(code, size, digest, bytes);
};
export var decode = function decode(multihash) {
  var bytes = coerce(multihash);

  var _varint$decode = varint.decode(bytes),
      _varint$decode2 = _slicedToArray(_varint$decode, 2),
      code = _varint$decode2[0],
      sizeOffset = _varint$decode2[1];

  var _varint$decode3 = varint.decode(bytes.subarray(sizeOffset)),
      _varint$decode4 = _slicedToArray(_varint$decode3, 2),
      size = _varint$decode4[0],
      digestOffset = _varint$decode4[1];

  var digest = bytes.subarray(sizeOffset + digestOffset);

  if (digest.byteLength !== size) {
    throw new Error('Incorrect length');
  }

  return new Digest(code, size, digest, bytes);
};
export var equals = function equals(a, b) {
  if (a === b) {
    return true;
  } else {
    return a.code === b.code && a.size === b.size && equalBytes(a.bytes, b.bytes);
  }
};
export var Digest = function Digest(code, size, digest, bytes) {
  _classCallCheck(this, Digest);

  this.code = code;
  this.size = size;
  this.digest = digest;
  this.bytes = bytes;
};